export default "__VITE_ASSET__CWVGtq7d__"